import { Leaf } from "lucide-react";

export function ProductPlaceholder({ name, className = "" }) {
  return (
    <div
      className={`relative flex flex-col items-center justify-center bg-gradient-to-br from-brand-green to-brand-greenLight text-white overflow-hidden ${className}`}
      data-testid="product-placeholder"
    >
      <Leaf className="w-10 h-10 text-brand-gold mb-2" strokeWidth={1.5} />
      <span className="font-serif text-2xl">{name}</span>
      <span className="text-[11px] uppercase tracking-widest text-white/50 mt-1">Photo réelle à venir</span>
    </div>
  );
}
